import React, { useState } from 'react'
import { Container, Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { EditableDropdown, Loader, SubHeader } from '../../../components'
import {
  HeaderRow,
  TableRow,
  DropdownCol,
  CompletedSessionTable,
  CompletedSessionWrapper
} from './subcomponents'
import { RootState } from '../../../redux/store'
import { getSessions } from '../../../redux/live/action'
import { formatDate, getSubjectLogo } from '../../../helpers'
import { SelectedSubject } from './typing'

const CompletedSessionsTable = () => {
  const {
    isLoading,
    isMenuOpen,
    sessions,
    batchList = [],
    branchList = [],
    coachingCentreId = '',
    sessionDetails
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.live.isLoading,
      isMenuOpen: state.menu.isMenuOpen,
      sessions: state.live.completedSessions,
      batchList: state.user?.userInfo?.userDetail?.batchList,
      branchList: state.user?.userInfo?.userDetail?.branchList,
      coachingCentreId: state.user?.userInfo?.userDetail?.coachingCentre?.id,
      sessionDetails: state.live.sessionDetails
    }),
    shallowEqual
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    location: { state }
  } = history
  const { name } = state as SelectedSubject
  const [subjectName, setsubjectName] = useState(name)
  const batchIds = batchList.map((batch) => batch.id)
  const branchIds = branchList.map((branch) => branch.id)
  const requestDate = {
    batchIds,
    branchIds,
    coachingCentreId
  }

  const parseTime = (t: string): number => {
    const time = t.split(':')
    return parseInt(time[0], 10) * 60 + parseInt(time[1], 10)
  }

  const dropdownSelectHandler = ({ id, name }: SelectedSubject) => {
    dispatch(getSessions({ ...requestDate, subjectId: id }))
    setsubjectName(name)
  }

  const tableHeader = [
    'Session Name',
    'Faculty Name',
    'Date',
    'Time',
    'Duration',
    'Recorded video'
  ]
  return (
    <CompletedSessionWrapper isMenuOpen={isMenuOpen}>
      <Container fluid>
        <HeaderRow>
          <Col sm={9}>
            <SubHeader
              title={subjectName}
              logo={getSubjectLogo({
                subject: subjectName || ''
              })}
              handleBack={() => {
                history.goBack()
              }}
            />
          </Col>
          <DropdownCol sm={3}>
            <EditableDropdown
              dropdownList={sessions.map(({ courseName, id }) => ({
                name: courseName,
                id
              }))}
              handleSelect={dropdownSelectHandler}
              placeholder="Subject"
            />
          </DropdownCol>
        </HeaderRow>
        {isLoading ? (
          <Loader />
        ) : (
          <TableRow className="justify-content-md-center">
            <CompletedSessionTable
              tableHeader={tableHeader}
              completedSessions={sessionDetails.map(
                ({
                  sessionName,
                  facultyName,
                  sessionDate,
                  startTime,
                  endTime,
                  sessionRecordingUrl
                }) => ({
                  name: sessionName,
                  facultyName,
                  date: formatDate(sessionDate),
                  time: startTime,
                  duration: `${parseTime(endTime) - parseTime(startTime)}min`,
                  url: sessionRecordingUrl
                })
              )}
            />
          </TableRow>
        )}
      </Container>
    </CompletedSessionWrapper>
  )
}

export default CompletedSessionsTable
